// Every cash movement in date order, laid out as Risk's own sheet (TX-US-0026): numbered, what
// moves and the share of it, the point it falls due from, when, how much and which way, and the
// net cash after it. Where it comes from - which supplier PO - sits under the event.
// A net cash below zero is bracketed and set on the wash - the palette's emphasis, not a red.
// Beside each amount and net cash, a question mark opens the formula that reached it (TX-TSK-0126).

import FormulaTip from './FormulaTip.jsx';
import { amountTex, netCashTex } from './formulaTex.js';
import { eventName } from './eventNames.js';
import { day, money } from './format.js';

// The amount as it is sent, without its sign: no figure passes through a float.
const unsigned = (amount) => amount.replace(/^-/, '');

// To the cent, as the sheet it replaces.
const EXACT = { exact: true };

export default function EventTable({ result }) {
  const c = result.currency;
  return (
    <div className="table-scroll">
      <table className="data-table econ-events">
        <thead>
          <tr>
            <th className="num">Event</th>
            <th>Event / cost</th>
            <th>Triggered by</th>
            <th>Payment date</th>
            <th className="num">Amount</th>
            <th>Type</th>
            <th className="num">Cash flow</th>
            <th className="num">Net cash</th>
          </tr>
        </thead>
        <tbody>
          {result.events.map((e, i) => (
            <tr key={i} className={`econ-row-${e.category.toLowerCase()}`}>
              <td className="num">{i + 1}</td>
              <td>
                {eventName(e)}
                <span className="econ-event-source">{e.source}</span>
              </td>
              <td>{e.trigger ?? '—'}</td>
              <td>{day(e.date)}</td>
              <td className="num">
                {money(unsigned(e.amount), c, EXACT)}
                <FormulaTip caption="Amount" title={eventName(e)} tex={amountTex(e, c)} />
              </td>
              <td>
                {Number(e.amount) >= 0 ? (
                  <span className="econ-direction is-in">IN</span>
                ) : (
                  <span className="econ-direction is-out">OUT</span>
                )}
              </td>
              <td className="num">{money(e.amount, c, EXACT)}</td>
              <td className={`num${Number(e.balance) < 0 ? ' econ-below-zero' : ''}`}>
                {money(e.balance, c, EXACT)}
                <FormulaTip
                  caption="Net cash"
                  title={`After event ${i + 1}`}
                  tex={netCashTex(
                    { ...e, name: eventName(e) },
                    i ? { balance: result.events[i - 1].balance, number: i } : null,
                    c,
                  )}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
